module.exports = __webpack_public_path__ + "img/img_product_FGF_11.efb59499.jpg";